import { Routes, Route } from "react-router-dom";
import UserProfile from "../pages/User/Profile";
import UpdateProfile from "../pages/User/UpdateProfile";
import NotFoundPage from '../pages/404'
import MusicView from "../pages/User/Music"
import EditMusic from '../pages/User/UpdateMusic'
import UploadMusic from '../pages/User/UploadMusic'
import AllMusic from "../pages/User/AllMusic";
import SettingsPage from "../pages/User/Settings";
import MyDashboard from "../pages/User/UserDashboard";
import Royalties from "../pages/User/Royalties";
import UpdateRoyaltiesAccount from "../pages/User/UpdateRoyaltiesAccount"
import SubscriptionHistory from "../pages/User/SubscriptionHistory";
import Main from "../pages/User/Home"

const Router = () => {
  return (
    <>
      <Routes>
         <Route path="/my-profile" element={<MyDashboard><UserProfile /></MyDashboard>} />
         <Route path="/my-profile/edit/:id" element={<MyDashboard><UpdateProfile /></MyDashboard>} />
         <Route path="/my-royalties/:id" element={<MyDashboard><Royalties/></MyDashboard>} />
         <Route path="/my-royalties/update-account" element={<MyDashboard><UpdateRoyaltiesAccount /></MyDashboard>} />
         <Route path="/my-music/:id" element={<MyDashboard><MusicView /></MyDashboard>} />
         <Route path="/my-music/edit/:id" element={<MyDashboard><EditMusic /></MyDashboard>} />
         <Route path="/upload-music" element={<MyDashboard><UploadMusic /></MyDashboard>} />
         <Route path="/my-dashboard" element={<MyDashboard><Main/></MyDashboard>} />
         <Route path="/my-dashboard/music/all" element={<MyDashboard><AllMusic/></MyDashboard>} />
         <Route path="/my-dashboard/settings" element={<MyDashboard><SettingsPage/></MyDashboard>} />
         <Route path="/my-subscription-history" element={<MyDashboard><SubscriptionHistory/></MyDashboard>} />
         <Route path="*" Component={NotFoundPage} />
      </Routes>
    </>
  );
};

export default Router;
